import 'css-chunksrc/client/scenes/optimizedGantt/zoomMenu/styles.scss';export default {
  "zoomMenu": "_zoomMenu_1tkqx_1",
  "button": "_button_1tkqx_10",
  "disabled": "_disabled_1tkqx_26"
};